module.exports = __webpack_public_path__ + "assets/img/Auxiliary materials (13).96d54450.png";